module.exports = __webpack_public_path__ + "img/stalking-paa-snapchat-1.8c21efb0.png";